const day = 86_400_000;
function dateOnly(value: string | null | undefined) {
 const date = value?.slice(0, 10);
 return date && /^\d{4}-\d{2}-\d{2}$/.test(date) && Number.isFinite(Date.parse(date)) && new Date(date).toISOString().slice(0, 10) === date ? date : null;
}
export function nextRenewalStart(endDate: string | null | undefined) {
 const end = dateOnly(endDate);
 return end ? new Date(Date.parse(end) + day).toISOString().slice(0, 10) : null;
}
/** Keep the previous agreement's calendar term, including leap-year boundaries. */
export function membershipRenewalPeriod(startDate: string | null | undefined, endDate: string | null | undefined) {
 const oldStart = dateOnly(startDate), oldEnd = dateOnly(endDate), start = nextRenewalStart(endDate);
 if (!oldStart || !oldEnd || !start || oldStart > oldEnd) return null;
 const addMonths = (value: string, months: number) => {
  const source = new Date(value), target = new Date(Date.UTC(source.getUTCFullYear(), source.getUTCMonth() + months, 1));
  const last = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)).getUTCDate();
  target.setUTCDate(Math.min(source.getUTCDate(), last));
  return target.toISOString().slice(0, 10);
 };
 const months = (Number(start.slice(0, 4)) - Number(oldStart.slice(0, 4))) * 12 + Number(start.slice(5, 7)) - Number(oldStart.slice(5, 7));
 const duration = Date.parse(start) - Date.parse(oldStart);
 const exclusiveEnd = months > 0 && addMonths(oldStart, months) === start ? Date.parse(addMonths(start, months)) : Date.parse(start) + duration;
 return { start, end: new Date(exclusiveEnd - day).toISOString().slice(0, 10) };
}
